export enum SISAttendanceType {
  Absent,
  Present
}
